define("shared/utils/social-profile-link", ["exports", "later/utils/constants"], function (_exports, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = socialProfileLink;
  0; //eaimeta@70e063a35619d71f0,"later/utils/constants"eaimeta@70e063a35619d71f
  /**
   * @param profile SocialProfileModel
   * @returns a formatted URL based on the passed social profile type
   */
  function socialProfileLink(profile) {
    switch (profile.profileType) {
      case _constants.SocialProfileType.Instagram:
        return `https://www.instagram.com/${profile.nickname}`;
      case _constants.SocialProfileType.Facebook:
        if (profile.nickname) {
          return `https://www.facebook.com/${profile.nickname}-${profile.uid}`;
        }
        return `https://www.facebook.com/${profile.urlName}`;
      case _constants.SocialProfileType.Tiktok:
        if (profile.nickname) {
          return `https://www.tiktok.com/@${profile.nickname}`;
        }
        return `https://www.tiktok.com/@${profile.urlName}`;
      case _constants.SocialProfileType.Twitter:
        return `https://twitter.com/${profile.nickname}`;
      case _constants.SocialProfileType.Pinterest:
        return `https://www.pinterest.com/${profile.nickname}`;
      case _constants.SocialProfileType.Linkedin:
        if (profile.urlName?.includes('https')) {
          return profile.urlName;
        }
        if (profile.isLinkedinPersonalProfile) {
          return `https://www.linkedin.com/in/${profile.nickname}`;
        }
        return `https://www.linkedin.com/company/${profile.nickname}`;
      default:
        return '';
    }
  }
});